import React, { useMemo } from 'react';
import PeopleSelect from 'reusable-components/book-block/BookBlockPeopleSelector/PeopleSelect';
import PersonOutlineIcon from 'reusable-components/icons/outline/PersonOutlineIcon';
import PopoverInput from 'reusable-components/inputs/PopoverInput';

interface BookBlockPeopleSelectorProps {
  nrOfAdults: number;
  nrOfChildren: number;
  maxPeople: number;
  formattedPrice: string;
  onContactHost: () => void;
  onAdultsChange: (adults: number) => void;
  onChildrenChange: (children: number) => void;
}

function BookBlockPeopleSelector({
  nrOfAdults,
  nrOfChildren,
  maxPeople,
  formattedPrice,
  onContactHost,
  onAdultsChange,
  onChildrenChange,
}: BookBlockPeopleSelectorProps) {
  const value = useMemo(() => {
    const totalPeople = nrOfAdults + nrOfChildren;
    if (totalPeople === 1) {
      return `1 Adult`;
    }
    return totalPeople > nrOfAdults
      ? `${totalPeople} People`
      : `${totalPeople} Adults`;
  }, [nrOfAdults, nrOfChildren]);

  return (
    <PopoverInput
      icon={PersonOutlineIcon}
      placeholder="Select people"
      value={value}
      children={
        <PeopleSelect
          nrOfAdults={nrOfAdults}
          nrOfChildren={nrOfChildren}
          maxPeople={maxPeople}
          formattedPrice={formattedPrice}
          onContactHost={onContactHost}
          onAdultsChange={onAdultsChange}
          onChildrenChange={onChildrenChange}
        />
      }
    />
  );
}

export default BookBlockPeopleSelector;
